import { PortalErrorStateScheduleEnum } from '../portal-error-state-schedule.enum';

export enum PortalCashOperationsWithdrawalsFormErrorStatesEnum {
  RegisterWithdrawalFailed = PortalErrorStateScheduleEnum.PortalCashOperationsWithdrawalsFormStatesStartIndex,
}
